/* STUV gratis-verzendingsbalk (Claude, 17/10/2026)
   Toont in het winkelmandje hoeveel er nog ontbreekt tot gratis verzending.
   Drempels in eurocent per land; moeten gelijk blijven aan de verzendzones in Shopify. */
(function () {
  var DREMPELS = { BE: 6000, NL: 7500, DE: 7500, LU: 7500 };
  var LANDEN_NL = { BE: 'België', NL: 'Nederland', DE: 'Duitsland', LU: 'Luxemburg' };
  var LANDEN_EN = { BE: 'Belgium', NL: 'the Netherlands', DE: 'Germany', LU: 'Luxembourg' };
  var land = (window.STUV_COUNTRY || '').toUpperCase();
  var en = (window.STUV_LOCALE || 'nl').toLowerCase().indexOf('en') === 0;
  var drempel = DREMPELS[land];
  if (!drempel) return;
  var geld = new Intl.NumberFormat(en ? 'en-BE' : 'nl-BE', { style: 'currency', currency: 'EUR' });
  var laatsteTotaal = null;

  function tekst(totaal) {
    var rest = drempel - totaal;
    var naam = en ? LANDEN_EN[land] : LANDEN_NL[land];
    if (rest <= 0) return en ? 'Free shipping to ' + naam + ' unlocked' : 'Je verzending naar ' + naam + ' is gratis';
    var bedrag = geld.format(rest / 100);
    return en ? 'Only ' + bedrag + ' to go for free shipping to ' + naam : 'Nog ' + bedrag + ' tot gratis verzending naar ' + naam;
  }

  function maak(totaal) {
    var el = document.createElement('div');
    el.className = 'stuv-fs';
    el.setAttribute('role', 'status');
    el.innerHTML = '<p class="stuv-fs__tekst"></p><div class="stuv-fs__balk" aria-hidden="true"><span></span></div>';
    vul(el, totaal);
    return el;
  }

  function vul(el, totaal) {
    var pct = Math.max(0, Math.min(100, Math.round((totaal / drempel) * 100)));
    var p = el.querySelector('.stuv-fs__tekst');
    var t = tekst(totaal);
    if (p.textContent !== t) p.textContent = t;
    var b = el.querySelector('.stuv-fs__balk span');
    if (b.style.width !== pct + '%') b.style.width = pct + '%';
    var klaar = totaal >= drempel;
    if (el.classList.contains('stuv-fs--klaar') !== klaar) el.classList.toggle('stuv-fs--klaar', klaar);
  }

  function plaats(totaal) {
    var doelen = [];
    var drawerHeader = document.querySelector('cart-drawer .drawer__header');
    if (drawerHeader) doelen.push({ ouder: drawerHeader.parentNode, na: drawerHeader });
    var paginaTitel = document.querySelector('cart-items .title-wrapper-with-link');
    if (paginaTitel) doelen.push({ ouder: paginaTitel.parentNode, na: paginaTitel });
    doelen.forEach(function (d) {
      var bestaand = d.ouder.querySelector(':scope > .stuv-fs');
      var leeg = totaal <= 0;
      if (leeg) { if (bestaand) bestaand.remove(); return; }
      if (bestaand) vul(bestaand, totaal);
      else d.na.insertAdjacentElement('afterend', maak(totaal));
    });
  }

  function ververs() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { laatsteTotaal = cart.total_price || 0; plaats(laatsteTotaal); })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(ververs, 150); }).catch(function () {});
    }
    return p;
  };

  var observer = new MutationObserver(function () {
    if (laatsteTotaal !== null) plaats(laatsteTotaal);
  });

  function start() {
    ververs();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    var items = document.querySelector('cart-items');
    if (items) observer.observe(items, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
